import React from "react";

interface Props {
  sectionTitle: string | null;
  line: string | null;
  isPage?: boolean | false;
}

const ServiceProcessGif: React.FC<Props> = ({ sectionTitle, line, isPage }) => {
  const [isVisible, setIsVisible] = React.useState<{ [key: string]: boolean }>({
    svg1: false,
    svg2: false,
    svg3: false,
  });

  const svgRefs = React.useRef<(HTMLImageElement | null)[]>([]);

  React.useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const key = entry.target.getAttribute("data-key") as string;
        if (key && isVisible.hasOwnProperty(key)) {
          if (entry.isIntersecting) {
            setIsVisible((prev) => ({ ...prev, [key]: true }));
          }
        }
      });
    }, { threshold: 0.5 });

    svgRefs.current.forEach((ref) => {
      if (ref) observer.observe(ref);
    });

    return () => {
      svgRefs.current.forEach((ref) => {
        if (ref) observer.unobserve(ref);
      });
    };
  }, []); // Empty dependency array to ensure it's set up once

  const renderSectionTitle = () => {
    if (!sectionTitle) return null;
    const TitleTag = isPage ? "h2" : "p";
    return (
      <TitleTag
        className="text-center font-16 text-black ff-semibold mb-4"
        dangerouslySetInnerHTML={{ __html: sectionTitle }}
      />
    );
  };

  const renderLine = () => {
    return line ? (
      <p className="font-12 text-grey ff-normal text-center">{line}</p>
    ) : null;
  };

  const renderImageColumn = (index: number, src: string, alt: string) => (
    <div className={index === 1 ? "" : "col-4"}>  {/* Check if the index is 1 */}
      <img
        ref={(el) => (svgRefs.current[index] = el)}
        data-key={`svg${index + 1}`} // Data attribute for the key
        src={`${src}?t=${Date.now()}`}
        className={`animatedd-svg d-block mx-auto img-fluid ${isVisible[`svg${index + 1}`] ? "visible" : "hidden"}`}
        alt={alt}
        style={{ width: "100%", height: "auto", objectFit: "contain" }} // Ensure consistent size and aspect ratio
      />
    </div>
  );

  return (
    <div className="container">
      <div className="applicable-main-wrap py-4">
        {renderSectionTitle()}
        {renderLine()}
        <div className="row">
          {renderImageColumn(0, "https://goodhand.b-cdn.net/Assets/cart/animate1.svg", "Animated 1")}
          <div className="col-4">
            <p className="font-12 mb-0 font-sm-8 text-black ff-bold text-center">
              Speed That Saves You Time
            </p>
            {renderImageColumn(1, "https://goodhand.b-cdn.net/Assets/cart/gauge-main.svg", "Gauge Animation")}
            <p className="font-10 mb-0 text-grey text-center ff-medium">
              Why It's Easy to Apply
            </p>
          </div>
          {renderImageColumn(2, "https://goodhand.b-cdn.net/Assets/cart/animate-3.svg", "Animated 3")}
        </div>
      </div>
    </div>
  );
};

export default ServiceProcessGif;
